import { Form } from '@mairistem/composants';
import { type Tiers, TiersIbanList } from '@mairistem/comptabilite';
import { Combobox } from '@mairistem/finances-utils';
import React from 'react';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';

interface TiersFichePanelInformationsBancairesProps {
	tiers: Tiers;
	onChange: (changes: Partial<Tiers>) => void;
}

const TiersFichePanelInformationsBancaires = ({
	tiers,
	onChange,
}: TiersFichePanelInformationsBancairesProps) => {
	const {
		modeReglementDepense = '',
		modeReglementRecette = '',
		ribs = [],
		deletedRibs = [],
		nom = '',
		prenom = '',
	} = tiers || {};

	const defaultTitulaire = [nom, prenom].filter(Boolean).join(' ');

	const handleChange = (_e, { name, value }) => {
		if (onChange) {
			onChange({ [name]: value });
		}
	};

	return (
		<Form>
			<Form.Group widths="equal">
				<Form.Field
					control={Combobox}
					key="modeReglementDepense"
					label="Mode de règlement en dépense"
					placeholder="Mode de règlement en dépense"
					name="modeReglementDepense"
					onChange={handleChange}
					options={MODE_REGLEMENT.DEPENSE_LIST}
					selection
					value={modeReglementDepense}
				/>
				<Form.Field
					control={Combobox}
					key="modeReglementRecette"
					label="Mode de règlement en recette"
					placeholder="Mode de règlement en recette"
					name="modeReglementRecette"
					onChange={handleChange}
					options={MODE_REGLEMENT.RECETTE_LIST}
					selection
					value={modeReglementRecette}
				/>
			</Form.Group>
			<TiersIbanList
				onChange={onChange}
				ribs={ribs}
				deletedRibs={deletedRibs}
				defaultTitulaire={defaultTitulaire}
			/>
		</Form>
	);
};

export default TiersFichePanelInformationsBancaires;
